import { ScrollView, StyleSheet, View } from 'react-native';
import { HelperText } from 'react-native-paper';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import Toast from 'react-native-toast-message';
import LoadingIndicator from 'src/presentation/components/molecules/LoadingIndicator';
import { Text } from 'src/presentation/components/atoms/Themed';
import { useAuthStore } from 'src/domain/stores/useAuthStore';
import { usePreferencesStore } from 'src/domain/stores/usePreferencesStore';
import { useServicesStore } from 'src/domain/stores/useServicesStore';
import Colors from 'src/core/utils/Colors';
import MenuRow from 'src/presentation/components/molecules/MenuRow';
import { useTabBarInset } from 'src/presentation/hooks/useTabBarInset';
import useAppStateScreenListener from 'src/presentation/hooks/useAppStateScreenListener';
import Dimens from 'src/core/utils/Dimens';
import Styles from 'src/core/utils/Styles';
import Fonts from 'src/core/utils/Fonts';
import Constants from 'src/core/utils/Constants';
import Translations from 'src/core/utils/Translations';

export default function MailPreferencesScreen() {
	const { user } = useAuthStore();
	const { emailNotifications, isLoading, errorMessage, getApiPreferences, putApiEmailNotificationPreference } =
		usePreferencesStore();
	const { logEvent } = useServicesStore();

	const insets = useSafeAreaInsets();
	const tabBarInset = useTabBarInset();

	useAppStateScreenListener({
		onInit: () => getApiPreferences(),
	});

	const saveEmailPreference = async (id: string, selected: boolean) => {
		await putApiEmailNotificationPreference({
			id,
			selected: !selected,
			onSuccess: () => {
				logEvent({
					name: Constants.analyticsEventChangeOptinSettings,
					params: {
						[Constants.analyticsParamScreenPage]: Constants.screenMailPreferences,
						[Constants.analyticsParamSelectItem]:
							id + ': ' + (!selected ? Constants.analyticsValueToggleOn : Constants.analyticsValueToggleOff),
					},
					user,
				});

				Toast.show({
					type: Constants.toastTypeSuccess,
					text2: Translations.yourAdjustmentHasBeenProcessedInOurDatabaseItMayTakeUpTo24HoursForYourAdjustmentToBeProcessed,
					bottomOffset: insets.bottom + Dimens.padding10,
				});
			},
		});
	};

	return (
		<View style={Styles.screen.white}>
			{isLoading ? (
				<LoadingIndicator style={{ flex: Dimens.flex1 }} />
			) : (
				<ScrollView contentContainerStyle={{ paddingBottom: tabBarInset }}>
					<HelperText type="error" visible={errorMessage !== null}>
						{errorMessage}
					</HelperText>
					<View style={{ paddingHorizontal: Dimens.padding18, paddingVertical: Dimens.padding20 }}>
						<Text style={styles.description}>{Translations.accountEmailDescriptionPreferences}</Text>
					</View>
					<View style={{ paddingHorizontal: Dimens.padding18 }}>
						<View style={styles.divider} />
					</View>
					{emailNotifications &&
						Object.entries(emailNotifications).map(([key, notification]) => {
							return (
								<MenuRow
									key={key}
									label={notification.name}
									switch={true}
									value={notification.selected}
									onPress={() => saveEmailPreference(notification.id, notification.selected)}
									onValueChange={() => saveEmailPreference(notification.id, notification.selected)}
								/>
							);
						})}
				</ScrollView>
			)}
		</View>
	);
}

const styles = StyleSheet.create({
	description: {
		color: Colors.gray500,
		lineHeight: Dimens.lineHeight22,
		fontFamily: Fonts.barlowMedium,
		fontSize: Dimens.fontSize16,
	},
	divider: {
		borderColor: Colors.gray200,
		borderBottomWidth: Dimens.borderWidth1,
	},
});
